import { render, staticRenderFns } from "./FavoriteGoods.vue?vue&type=template&id=e7461baa&scoped=true"
import script from "./FavoriteGoods.vue?vue&type=script&lang=js"
export * from "./FavoriteGoods.vue?vue&type=script&lang=js"
import style0 from "./FavoriteGoods.vue?vue&type=style&index=0&id=e7461baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7461baa",
  null
  
)

export default component.exports